import { render, staticRenderFns } from "./PhotoTabView.vue?vue&type=template&id=5fcd6043&scoped=true&"
import script from "./PhotoTabView.vue?vue&type=script&lang=js&"
export * from "./PhotoTabView.vue?vue&type=script&lang=js&"
import style0 from "./PhotoTabView.vue?vue&type=style&index=0&id=5fcd6043&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd6043",
  null
  
)

export default component.exports